

// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import ApiService from './ApiService';
// import { useUser } from './UserContext';

// const LearningPreferencesContext = createContext();
// const apiService = new ApiService();

// export function LearningPreferencesProvider({ children }) {
//   const { userId } = useUser();
//   const [preferredLearningOrder, setPreferredLearningOrder] = useState([]);
//   const [topics, setTopics] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   const targetLanguage = 'KR';
//   const sourceLanguage = 'EN';

//   const fetchPreferencesData = useCallback(async () => {
//     if (!userId) {
//       setLoading(false);
//       return;
//     }
    
//     setLoading(true);
//     try {
//       const [topicsData, preferredLearningData] = await Promise.all([
//         apiService.getAllVocabTopics(targetLanguage, sourceLanguage),
//         apiService.getUserPreferredLearningList(userId, targetLanguage)
//       ]);
      
//       setTopics(topicsData);
//       setPreferredLearningOrder(preferredLearningData.learning_order || []);
//     } catch (error) {
//       console.error('Error fetching learning preferences:', error);
//     } finally {
//       setLoading(false);
//     }
//   }, [userId, targetLanguage, sourceLanguage]);

//   useEffect(() => {
//     fetchPreferencesData();
//   }, [fetchPreferencesData]);

//   // const updatePreferredLearningOrder = async (newOrder) => {
//   //   try {
//   //     await apiService.upsertUserPreferredLearningList(userId, targetLanguage, newOrder);
//   //     setPreferredLearningOrder(newOrder);
//   //   } catch (error) {
//   //     console.error('Error updating preferred learning order:', error);
//   //     throw error;
//   //   }
//   // };

//     const updatePreferredLearningOrder = async (newOrder) => {
//       console.log('📥 updatePreferredLearningOrder called with:', newOrder);
//       console.log('📥 userId:', userId);
//       console.log('📥 targetLanguage:', targetLanguage);
      
//       try {
//         console.log('🔄 Calling API service...');
//         const result = await apiService.upsertUserPreferredLearningList(userId, targetLanguage, newOrder);
        
//         console.log('✅ API call successful, result:', result);
        
//         console.log('🔄 Updating local state...');
//         console.log('   Old state:', preferredLearningOrder);
//         console.log('   New state:', newOrder);
        
//         setPreferredLearningOrder(newOrder);
        
//         console.log('✅ Local state updated');
        
//         return result; // Return the result in case the caller needs it
//       } catch (error) {
//         console.error('❌ Error updating preferred learning order:', error);
//         console.error('❌ Failed with order:', newOrder);
//         console.error('❌ Error details:', error.response?.data || error.message);
//         throw error;
//       }
//   };


//   const refreshPreferences = useCallback(async () => {
//     await fetchPreferencesData();
//   }, [fetchPreferencesData]);

//   // Helper function to get displayable info about the active learning source
//   const getActiveStudySource = () => {
//     if (preferredLearningOrder.length === 0 || preferredLearningOrder[0] === '__DEFAULT__') {
//       return {
//         id: '__DEFAULT__',
//         type: 'default',
//         displayName: 'Default Frequency-Based Learning',
//         icon: '📚',
//         count: null
//       };
//     }

//     const activeId = preferredLearningOrder[0];
    
//     // Check if it's a vocab topic
//     if (activeId.startsWith('vocab_topics-')) {
//       const parts = activeId.split('-');
//       const topicName = parts.slice(3).join('-');
      
//       const topic = topics.find(t => t.target_topic_name === topicName);
      
//       if (topic) {
//         return {
//           id: activeId,
//           type: 'topic',
//           displayName: `Vocab Topic: ${topic.target_topic_name}`,
//           icon: '🎯',
//           count: topic.target_vocab?.length || 0,
//           data: topic
//         };
//       }
//     }
    
//     // Check if it's a custom list
//     if (activeId.startsWith('user_vocab_lists-')) {
//       const parts = activeId.split('-');
//       const listName = parts.slice(2).join('-');
      
//       return {
//         id: activeId,
//         type: 'custom',
//         displayName: `Custom List: ${listName}`,
//         icon: '📝',
//         count: null
//       };
//     }

//     // Fallback
//     return {
//       id: activeId,
//       type: 'unknown',
//       displayName: 'Custom Learning Path',
//       icon: '📖',
//       count: null
//     };
//   };

//   return (
//     <LearningPreferencesContext.Provider value={{
//       preferredLearningOrder,
//       topics,
//       loading,
//       updatePreferredLearningOrder,
//       refreshPreferences,
//       getActiveStudySource,
//       targetLanguage,
//       sourceLanguage
//     }}>
//       {children}
//     </LearningPreferencesContext.Provider>
//   );
// }

// export function useLearningPreferences() {
//   const context = useContext(LearningPreferencesContext);
//   if (!context) {
//     throw new Error('useLearningPreferences must be used within a LearningPreferencesProvider');
//   }
//   return context;
// }





import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import ApiService from './ApiService';
import { useUser } from './UserContext';

const LearningPreferencesContext = createContext();
const apiService = new ApiService();

export function LearningPreferencesProvider({ children }) {
  const { userId } = useUser();
  const [preferredLearningOrder, setPreferredLearningOrder] = useState([]);
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastFetchTime, setLastFetchTime] = useState(null);
  const [topicsFetched, setTopicsFetched] = useState(false);
  
  const targetLanguage = 'KR';
  const sourceLanguage = 'EN';

  // Initial fetch on mount - don't use useCallback to avoid dependency issues
  useEffect(() => {
    const fetchData = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }
      
      // Don't refetch if we fetched within the last 30 seconds
      const now = Date.now();
      if (lastFetchTime && (now - lastFetchTime < 30000)) {
        console.log('Skipping preferences fetch - too recent');
        return;
      }
      
      setLoading(true);
      try {
        // Fetch topics only once
        const topicsPromise = !topicsFetched
          ? apiService.getAllVocabTopics(targetLanguage, sourceLanguage)
          : Promise.resolve(topics);
        
        // Always fetch user preferences (they can change)
        const preferencesPromise = apiService.getUserPreferredLearningList(userId, targetLanguage);
        
        const [topicsData, preferredLearningData] = await Promise.all([
          topicsPromise,
          preferencesPromise
        ]);
        
        if (!topicsFetched) {
          setTopics(topicsData);
          setTopicsFetched(true);
          console.log('Vocab topics fetched');
        }
        
        setPreferredLearningOrder(preferredLearningData.learning_order || []);
        setLastFetchTime(now);
        console.log('Learning preferences fetched:', preferredLearningData.learning_order);
      } catch (error) {
        console.error('Error fetching learning preferences:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [userId, lastFetchTime, topics, topicsFetched]); // Only depend on userId to avoid infinite loops

  const updatePreferredLearningOrder = async (newOrder) => {
    console.log('📥 updatePreferredLearningOrder called with:', newOrder);
    console.log('📥 userId:', userId);
    console.log('📥 targetLanguage:', targetLanguage);
    
    try {
      console.log('🔄 Calling API service...');
      const result = await apiService.upsertUserPreferredLearningList(userId, targetLanguage, newOrder);
      
      console.log('✅ API call successful, result:', result);
      
      console.log('🔄 Updating local state...');
      console.log('   Old state:', preferredLearningOrder);
      console.log('   New state:', newOrder);
      
      setPreferredLearningOrder(newOrder);
      
      console.log('✅ Local state updated');
      
      return result;
    } catch (error) {
      console.error('❌ Error updating preferred learning order:', error);
      console.error('❌ Failed with order:', newOrder);
      console.error('❌ Error details:', error.response?.data || error.message);
      throw error;
    }
  };

  // Force refresh - only call this when user explicitly changes preferences
  const refreshPreferences = useCallback(async () => {
    console.log('Force refreshing learning preferences...');
    
    if (!userId) return;
    
    setLoading(true);
    try {
      // Force refetch both topics and preferences
      const [topicsData, preferredLearningData] = await Promise.all([
        apiService.getAllVocabTopics(targetLanguage, sourceLanguage),
        apiService.getUserPreferredLearningList(userId, targetLanguage)
      ]);
      
      setTopics(topicsData);
      setTopicsFetched(true);
      setPreferredLearningOrder(preferredLearningData.learning_order || []);
      setLastFetchTime(Date.now());
      console.log('Learning preferences force refreshed');
    } catch (error) {
      console.error('Error refreshing learning preferences:', error);
    } finally {
      setLoading(false);
    }
  }, [userId, targetLanguage, sourceLanguage]);

  // Helper function to get displayable info about the active learning source
  const getActiveStudySource = () => {
    if (preferredLearningOrder.length === 0 || preferredLearningOrder[0] === '__DEFAULT__') {
      return {
        id: '__DEFAULT__',
        type: 'default',
        displayName: 'Default Frequency-Based Learning',
        icon: '📚',
        count: null
      };
    }

    const activeId = preferredLearningOrder[0];
    
    // Check if it's a vocab topic
    if (activeId.startsWith('vocab_topics-')) {
      const parts = activeId.split('-');
      const topicName = parts.slice(3).join('-');
      
      const topic = topics.find(t => t.target_topic_name === topicName);
      
      if (topic) {
        return {
          id: activeId,
          type: 'topic',
          displayName: `Vocab Topic: ${topic.source_topic_name}`,
          icon: '🎯',
          count: topic.target_vocab?.length || 0,
          data: topic
        };
      }
    }
    
    // Check if it's a custom list
    if (activeId.startsWith('user_vocab_lists-')) {
      const parts = activeId.split('-');
      const listName = parts.slice(2).join('-');
      
      return {
        id: activeId,
        type: 'custom',
        displayName: `Custom List: ${listName}`,
        icon: '📝',
        count: null
      };
    }

    // Fallback
    return {
      id: activeId,
      type: 'unknown',
      displayName: 'Custom Learning Path',
      icon: '📖',
      count: null
    };
  };

  return (
    <LearningPreferencesContext.Provider value={{
      preferredLearningOrder,
      topics,
      loading,
      updatePreferredLearningOrder,
      refreshPreferences,
      getActiveStudySource,
      targetLanguage,
      sourceLanguage
    }}>
      {children}
    </LearningPreferencesContext.Provider>
  );
}

export function useLearningPreferences() {
  const context = useContext(LearningPreferencesContext);
  if (!context) {
    throw new Error('useLearningPreferences must be used within a LearningPreferencesProvider');
  }
  return context;
}